import { useDebounceFn, useThrottleFn } from 'ahooks'

import { api } from '@/utils/api'

export function useMusicActivityTrack() {
  const { mutate } = api.music.statAudio.useMutation({
    trpc: {
      context: {
        ignoreError: true,
      },
    },
  })

  const { run: trackUserActivityDebounce } = useDebounceFn(
    (props: Parameters<typeof mutate>[0]) => {
      mutate(props)
    },
    {
      wait: 3000,
    },
  )

  const { run: trackUserActivityThrottle } = useThrottleFn(
    (props: Parameters<typeof mutate>[0]) => {
      mutate(props)
    },
    {
      wait: 8000,
    },
  )

  return {
    trackUserActivityDebounce,
    trackUserActivityThrottle,
  }
}
